// ראשון: השפה והכיוון נקבעים לפני שמודול אחר מחשב טקסט.
import '@/lib/i18n';
import { LocaleDirection } from '@/lib/locale-direction';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ToastProvider } from '@/components/ui/toast';
import { AuthProvider } from '@/lib/auth';
import { refreshContent } from '@/lib/content-sync';
import { currentLocale } from '@/lib/i18n';
import { queryClient } from '@/lib/query';
import { router } from '@/router';
import './styles/fonts.css';
import './styles/theme.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    {/* Radix מניח ltr כברירת מחדל ומדביק dir על השורש של כל primitive
        (Tabs, Select, Toast...). ההצהרה כאן — לפי שפת הממשק — חלה על כולם. */}
    <LocaleDirection>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </LocaleDirection>
  </StrictMode>,
);

// טקסטים שנערכו בקונסולת המפעיל (תנאים, דף נחיתה וכו') — מעל מה שבקוד.
void refreshContent(currentLocale());
